// @flow

import * as React from "react"
import ClassNames from "classnames"
import {withTranslation} from "react-i18next"

import type {Invoice} from "../../types"

type Props = {
  +invoice: ?Invoice,
  +t: any,
}

class InvoiceStatus extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
  }

  render() {
    const {invoice, t} = this.props
    if (!invoice) return null
    const {isFinal, isPaid, isDraftSent} = invoice
    const className = ClassNames("invoice-status", {
      "is-final": isFinal,
      "is-paid": isPaid,
    })
    return (
      <div className={className}>
        {isFinal && <span>{t(`invoice.final`)}</span>}
        {isPaid && <span>{t(`invoice.paid`)}</span>}
        {!isFinal && !isDraftSent ? <span>{t(`invoice.draft`)}</span> : null}
        {!isFinal && isDraftSent ? (
          <span>{t(`invoice.draft_sent`)}</span>
        ) : null}
      </div>
    )
  }
}

export default withTranslation()(InvoiceStatus)
